module.exports = __webpack_public_path__ + "static/media/Amino-Regular.e27f8d28.ttf";